import axios from 'axios';

export default {
  data() {
    return {
      checkingIdentityVerifications: false,
    };
  },

  methods: {
    async checkIdentityVerificationsForUpdate(taxReturnId, companyId) {
      try {
        this.checkingIdentityVerifications = true;

        const response = await axios.post(
          `/tax_returns/${taxReturnId}/tax_return_identity_verifications/check_for_update`,
          {
            company_id: companyId,
          },
        );

        if (this.identityVerifications) {
          this.identityVerifications = response.data;
        }
      } finally {
        this.checkingIdentityVerifications = false;
      }
    },
  },

  computed: {
    hasUnverifiedIdentityVerifications() {
      return (
        this.identityVerifications &&
        this.identityVerifications.some(identity => {
          return !identity.phone_number || !identity.phone_number_verified;
        })
      );
    },
  },
};
